<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="mb-2">
            <div class="dropdown">
              <a
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a class="dropdown-item rounded-1" @click.prevent="exportCsv" v-can="'Reports.Export'">
                    <i class="ti ti-file-type-xls me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a class="dropdown-item rounded-1" @click.prevent="exportPdf" v-can="'Reports.Export'">
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="row dq-stat-grid">
        <!-- KPI Cards -->
        <div class="col-xl-6 d-flex">
          <div class="row flex-fill">
            <div v-for="c in kpiCards" :key="c.title" class="col-md-6 d-flex">
              <div class="card flex-fill dq-stat-card">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2"
                  >
                    <div>
                      <span class="fs-14 fw-normal text-truncate mb-1">{{
                        c.title
                      }}</span>
                      <h5>
                        {{ currency }}
                        {{
                          Number(c.value).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </h5>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="avatar avatar-md avatar-rounded"
                      :class="`bg-transparent-${c.cls} border border-${c.cls}`"
                    >
                      <span :class="`text-${c.cls}`"
                        ><i class="ti ti-brand-shopee"></i
                      ></span>
                    </a>
                  </div>
                  <p
                    class="fs-12 fw-normal d-flex align-items-center text-truncate mb-0"
                  >
                    <span class="text-muted">Based on selected period</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart -->
        <div class="col-xl-6 d-flex">
          <div class="card flex-fill">
            <div class="card-header border-0 pb-0">
              <div
                class="d-flex flex-wrap justify-content-between align-items-center row-gap-3"
              >
                <div class="d-flex align-items-center">
                  <span class="me-2"
                    ><i class="ti ti-chart-area-line text-danger"></i
                  ></span>
                  <h5>Payroll</h5>
                </div>
                <div class="me-2" style="min-width: 180px">
                  <select v-model="filters.frequency" class="form-select" @change="onFrequencyChange">
                    <option value="">All Frequencies</option>
                    <option value="monthly">Monthly</option>
                    <option value="weekly">Weekly</option>
                    <option value="fortnightly">Fortnightly</option>
                    <option value="daily">Daily</option>
                  </select>
                </div>
                <div
                  class="input-icon-end position-relative"
                  style="min-width: 230px"
                >
                  <input
                    type="text"
                    class="form-control date-range bookingrange"
                    ref="dateRangeInput"
                    placeholder="dd/mm/yyyy - dd/mm/yyyy"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-chevron-down"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div id="payslip-chart">
                <apexchart
                  type="line"
                  height="200"
                  :options="payslipChart.sline"
                  :series="payslipChart.series"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Payslip List</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <PayslipReportTable
              :rows="store.payslipRows"
              :loading="store.payslipLoading"
              :currency="currency"
              :total="store.payslipTotal"
              :page-size="store.payslipPageSize"
              :current="store.payslipCurrent"
              @change="onTableChange"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
</template>

<style scoped>
@media (max-width: 767.98px) {
  .dq-page-actions {
    align-items: stretch !important;
  }

  .dq-page-actions > * {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .dq-page-actions .dropdown,
  .dq-page-actions .dropdown-toggle {
    width: 100%;
  }

  .dq-stat-card .card-body {
    padding: 1rem;
  }

  .input-icon-end.position-relative {
    min-width: 100% !important;
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";
import moment from "moment";
import { ref, reactive, onMounted, computed } from "vue";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";
import PayslipReportTable from "./payslip-report-table.vue";

const title = "Payslip Report";
const text = "HR";
const text1 = "Payslip Report";

const store = useEmployeeSalaryStore();

const dateRangeInput = ref(null);

// page filters (date range + pagination)
const filters = reactive({
  frequency: "",
  from_date: moment().startOf("year").format("YYYY-MM-DD"),
  to_date: moment().format("YYYY-MM-DD"),
  page: 1,
  per_page: 25,
});

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function initRangePicker() {
  if (!dateRangeInput.value) return;

  const start = moment(filters.from_date, "YYYY-MM-DD");
  const end = moment(filters.to_date, "YYYY-MM-DD");

  const onPick = (s, e) => {
    filters.from_date = moment(s).format("YYYY-MM-DD");
    filters.to_date = moment(e).format("YYYY-MM-DD");
    filters.page = 1;
    fetchReport();
  };

  new DateRangePicker(
    dateRangeInput.value,
    {
      startDate: start,
      endDate: end,
      showDropdowns: true,
      autoApply: true,
      ranges: {
        Today: [moment(), moment()],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Year to Date": [moment().startOf("year"), moment().endOf("month")],
        "Last Year": [
          moment().subtract(1, "year").startOf("year"),
          moment().subtract(1, "year").endOf("year"),
        ],
      },
    },
    onPick
  );
}

async function fetchReport() {
  await store.fetchPayslipReport({
    frequency: filters.frequency || undefined,
    from_date: filters.from_date,
    to_date: filters.to_date,
    page: filters.page,
    per_page: filters.per_page,
  });
}

function onFrequencyChange() {
  filters.page = 1;
  fetchReport();
}

function onTableChange(pagination) {
  filters.page = pagination.current;
  filters.per_page = pagination.pageSize;
  fetchReport();
}

function exportCsv() {
  store.exportPayslipReportCSV({
    frequency: filters.frequency || undefined,
    from_date: filters.from_date,
    to_date: filters.to_date,
  });
}

function exportPdf() {
  store.exportPayslipReportPDF({
    frequency: filters.frequency || undefined,
    from_date: filters.from_date,
    to_date: filters.to_date,
  });
}

// KPI cards
const summary = computed(() => store.payslipSummary || {});
const currency = computed(() => summary.value?.currency || "KES");

const kpiCards = computed(() => [
  {
    title: "Total Payroll",
    value: summary.value?.total_gross || 0,
    cls: "primary",
  },
  {
    title: "Deductions",
    value: summary.value?.total_deductions || 0,
    cls: "danger",
  },
  { title: "Net Pay", value: summary.value?.total_net || 0, cls: "success" },
  {
    title: "Allowances",
    value: summary.value?.total_allowances || 0,
    cls: "skyblue",
  },
]);

// Chart (apex)
const payslipChart = computed(() => ({
  sline: {
    chart: { type: "line", height: 200, toolbar: { show: false } },
    stroke: { width: 2, curve: "smooth" },
    dataLabels: { enabled: false },
    xaxis: { categories: (store.payslipSeries || []).map((m) => m.label) },
    yaxis: {
      labels: {
        formatter: (v) =>
          `${currency.value} ${Number(v).toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}`,
      },
    },
    tooltip: {
      y: {
        formatter: (v) =>
          `${currency.value} ${Number(v).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`,
      },
    },
    legend: { position: "top" },
  },
  series: [
    {
      name: "Gross",
      data: (store.payslipSeries || []).map((m) => m.gross || 0),
    },
    {
      name: "Deductions",
      data: (store.payslipSeries || []).map((m) => m.deductions || 0),
    },
    { name: "Net", data: (store.payslipSeries || []).map((m) => m.net || 0) },
  ],
}));

onMounted(() => {
  initRangePicker();
  fetchReport();
});
</script>


